import { makeAutoObservable, runInAction } from 'mobx';
import createStoreContext from '../createStoreContext';
import { ROLES } from 'src/constants/Role';
import { UserApiResponse, UsersByRoleResponse } from 'src/types/user';
import { getAllUsers } from 'src/services/user';
import {
  GET_ALL_USERS_API_LIMIT_VALUE,
  GET_ALL_USERS_API_PAGE_VALUE,
} from 'src/constants/upgradeRequest';

export const [UpgradeRequestStoreProvider, useUpgradeRequestStore] =
  createStoreContext(
    class UpgradeRequestStore {
      isUpgradeRequestPopupOpen = false;
      usersWithUserRole: UserApiResponse[] = [];
      usersWithAdminRole: UserApiResponse[] = [];

      public constructor() {
        makeAutoObservable(this);
      }

      openUpgradeRequestPopUp = () => {
        this.isUpgradeRequestPopupOpen = true;
      };

      closeUpgradeRequestPopUp = () => {
        this.isUpgradeRequestPopupOpen = false;
      };

      fetchAllUsersForUpgradeRequest = async (
        userDetails: UserApiResponse | undefined,
      ) => {
        if (!userDetails) {
          return null;
        }

        const { success: getAllUsersSuccess, content: allUsers } =
          await getAllUsers<UsersByRoleResponse[]>(
            GET_ALL_USERS_API_PAGE_VALUE,
            GET_ALL_USERS_API_LIMIT_VALUE,
            undefined,
            {
              roleBased: true,
              mongoUserIdsToExclude: [userDetails._id.toString()],
            },
          );

        if (!getAllUsersSuccess || !allUsers) {
          return null;
        }

        const usersWithUserRole: Array<UserApiResponse> = [];
        const usersWithAdminRole: Array<UserApiResponse> = [];
        const usersWithSuperAdminRole: Array<UserApiResponse> = [];

        allUsers.data.forEach(({ role, users }) => {
          if (role === ROLES.USER) {
            usersWithUserRole.push(...users);
          } else if (role === ROLES.ADMIN) {
            usersWithAdminRole.push(...users);
          } else if (role === ROLES.SUPER_ADMIN) {
            usersWithSuperAdminRole.push(...users);
          }
        });

        const combinedUsersAdminRole = [
          ...usersWithAdminRole,
          ...usersWithSuperAdminRole,
        ];

        runInAction(() => {
          this.usersWithUserRole = usersWithUserRole;
          this.usersWithAdminRole = combinedUsersAdminRole;
        });

        return {
          usersWithUserRole,
          usersWithAdminRole: combinedUsersAdminRole,
        };
      };
    },
  );

export type UpgradeRequestStore = ReturnType<typeof useUpgradeRequestStore>;
